import { Employee9BoxPerformanceTrend } from 'components/employee-analytics/analytic-item/Employee9BoxPerformanceTrend'
import { useState, useEffect } from 'react'
import { API_EMPLOYEE_ANALYTICS } from 'services/apiEmployeeAnalytics'
import { useFetch } from 'services/useFetch'

const INITIAL_FILTER = {
    nine_box_label: 'Falling Star',
    company_ids: [],
    department_ids: [],
    division_ids: [],
    sub_division_ids: [],
}

const Employee9BoxPerformanceTrendContainer = () => {
    const { fetching: getPerformanceTrend, isLoading } = useFetch(API_EMPLOYEE_ANALYTICS.NINE_BOX_PERFORMANCE_TREND)
    const [performanceTrendData, setPerformanceTrendData] = useState([])
    const [filter, setFilter] = useState(INITIAL_FILTER)

    useEffect(() => {
        ;(async () => {
            const performanceTrend = await getPerformanceTrend(filter)
            setPerformanceTrendData(performanceTrend?.data)
        })()
    }, [filter])

    const onSubmitFilter = (newFilter) => {
        if (JSON.stringify(filter) !== JSON.stringify(newFilter)) {
            setFilter(newFilter)
        }
    }

    const props = {
        data: performanceTrendData,
        isLoading,
        filter,
        onSubmitFilter,
    }

    return <Employee9BoxPerformanceTrend {...props} />
}

export default Employee9BoxPerformanceTrendContainer
